import React, { FC, useEffect, useState } from "react";
import { Button, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";

import { selectUserId } from "fond/api";
import { useSwitchableAccounts } from "fond/hooks/useSwitchableAccounts";
import { setAccountContext } from "fond/utils/accountContextStorage";
import { useAppSelector } from "fond/utils/hooks";
import { Avatar } from "fond/widgets";
import { AccountContent } from "fond/widgets/AccountSwitch/AccountBox.styles";
import PageCentred from "fond/widgets/PageCentred/PageCentred";

const SelectAccount: FC = () => {
  const { accounts } = useSwitchableAccounts();
  const [selectedAccount, setSelectedAccount] = useState(accounts.at(0)?.ID || "");
  const userId = useAppSelector(selectUserId);

  useEffect(() => {
    // If we only have one account lets just select it and move on.
    if (accounts.length === 1 && userId) {
      setAccountContext(userId, accounts[0].ID);
    }
  }, [userId, accounts]);

  const handleOnClick = () => {
    if (userId && selectedAccount) {
      setAccountContext(userId, selectedAccount);
    }
  };
  const handleOnChange = (event: SelectChangeEvent<string>) => {
    setSelectedAccount(event.target.value);
  };

  const getAccount = (id: string, name: string) => {
    return (
      <AccountContent key={id}>
        <Avatar name={name} stringColor variant="rounded" />
        <Typography>{name}</Typography>
      </AccountContent>
    );
  };
  return (
    <PageCentred title="Select Workspace" icon={null} description="Please select the workspace you would like to view before proceeding.">
      <Select fullWidth defaultValue="" data-testid="select-account-select" value={selectedAccount} onChange={handleOnChange}>
        {accounts.map((account) => (
          <MenuItem key={account.ID} value={account.ID}>
            {getAccount(account.ID, account.Name)}
          </MenuItem>
        ))}
      </Select>
      <Button fullWidth variant="contained" sx={{ marginTop: 2 }} onClick={handleOnClick}>
        Continue
      </Button>
    </PageCentred>
  );
};

export default SelectAccount;
